import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Link, IconButton, Divider } from '@mui/material';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: '#d2b48c',
        color: 'white'
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Link href="/terms" color="inherit" underline="hover">
              {t('footer.terms')}
            </Link>
            <Link href="/privacy" color="inherit" underline="hover">
              {t('footer.privacy')}
            </Link>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Divider orientation="vertical" flexItem sx={{ bgcolor: 'rgba(255, 255, 255, 0.3)' }} />
            <a
              href="https://www.facebook.com/people/Rentlordonline/61556802369712"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <IconButton sx={{ color: 'white' }}>
                <FacebookRoundedIcon />
              </IconButton>
            </a>
            <a
              href="https://www.instagram.com/rentlord.online/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <IconButton sx={{ color: 'white' }}>
                <InstagramIcon />
              </IconButton>
            </a>
            <a
              href="https://x.com/RentlordOnline"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <IconButton sx={{ color: 'white' }} aria-label="X">
                <XIcon />
              </IconButton>
            </a>
          </Box>

          <Typography variant="body2">
            © {new Date().getFullYear()} RentLord
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;